import { StoreDrawer } from "./../_module/_click/storeDrawer";
import { SwiperContainer } from "./../_module/_carousel/swiper";
import { Opening } from "./../_module/_animation/opening";
import { LetterMotion } from "./../_module/_text/letterMotion";

export const Faq = {
  /**
   * funcs
   */
  init: ()=> {
    StoreDrawer.init();
    SwiperContainer.init();
    Opening.lowPageReady()
    LetterMotion.init(true)
  }
};
